import { FormValueScope } from '@epages/react-components'
import { fromJS } from 'immutable'
import SelectableInputField from '@epages/react-components/build/form/SelectableInputField'

import { useTranslate } from '../../utils/translate'

export default function SocialMediaPopover() {
  const t = useTranslate('interface', 'components.bottomBar.footerSettings.sections.popovers')

  return (
    <FormValueScope name="socialNetworks">
      <fieldset>
        <legend>{t('logoSelection.title')}</legend>
        <scroll-shadow>
          <div className="ep-footer-sections-settings-popover-column ep-footer-sections-settings-popover-social-media">
            <SelectableInputField
              name="facebookUrl"
              title={t('socialMediaSelection.facebook.tooltip')}
              aria-label={t('socialMediaSelection.facebook.ariaLabel')}
              label={t('socialMediaSelection.facebook.checkBoxAccessibilityLabel')}
            />
            <SelectableInputField
              name="twitterUrl"
              title={t('socialMediaSelection.twitter.tooltip')}
              aria-label={t('socialMediaSelection.twitter.ariaLabel')}
              label={t('socialMediaSelection.twitter.checkBoxAccessibilityLabel')}
            />
            <SelectableInputField
              name="pinterestUrl"
              title={t('socialMediaSelection.pinterest.tooltip')}
              aria-label={t('socialMediaSelection.pinterest.ariaLabel')}
              label={t('socialMediaSelection.pinterest.checkBoxAccessibilityLabel')}
            />
            <SelectableInputField
              name="instagramUrl"
              title={t('socialMediaSelection.instagram.tooltip')}
              aria-label={t('socialMediaSelection.instagram.ariaLabel')}
              label={t('socialMediaSelection.instagram.checkBoxAccessibilityLabel')}
            />
            <SelectableInputField
              name="youtubeUrl"
              title={t('socialMediaSelection.youtube.tooltip')}
              aria-label={t('socialMediaSelection.youtube.ariaLabel')}
              label={t('socialMediaSelection.youtube.checkBoxAccessibilityLabel')}
            />
            <SelectableInputField
              name="whatsappUrl"
              title={t('socialMediaSelection.whatsapp.tooltip')}
              aria-label={t('socialMediaSelection.whatsapp.ariaLabel')}
              label={t('socialMediaSelection.whatsapp.checkBoxAccessibilityLabel')}
            />
            <SelectableInputField
              name="tiktokUrl"
              title={t('socialMediaSelection.tiktok.tooltip')}
              aria-label={t('socialMediaSelection.tiktok.ariaLabel')}
              label={t('socialMediaSelection.tiktok.checkBoxAccessibilityLabel')}
            />
            <SelectableInputField
              name="linkedinUrl"
              title={t('socialMediaSelection.linkedin.tooltip')}
              aria-label={t('socialMediaSelection.linkedin.ariaLabel')}
              label={t('socialMediaSelection.linkedin.checkBoxAccessibilityLabel')}
            />
          </div>
        </scroll-shadow>
      </fieldset>
    </FormValueScope>
  )
}

SocialMediaPopover.defaultValue = fromJS({
  facebookUrl: '',
  facebookUrlSelected: true,
  twitterUrl: '',
  twitterUrlSelected: true,
  pinterestUrl: '',
  pinterestUrlSelected: true,
  instagramUrl: '',
  instagramUrlSelected: true,
  youtubeUrl: '',
  youtubeUrlSelected: true,
  whatsappUrl: '',
  whatsappUrlSelected: true,
  tiktokUrl: '',
  tiktokUrlSelected: true,
  linkedinUrl: '',
  linkedinUrlSelected: true,
})
